function Notification({ message }) {
  return (
    <p><strong>{message}</strong></p>
  )
}

export default Notification
